import Bowser from 'bowser';
import PcPlayer from './pcVideoAsync';
import FlashPlayer from './flashVideoAsync';

let isIE = false

if (typeof window !== 'undefined') {
    const browser = Bowser.getParser(window.navigator.userAgent);
    
    if(browser.is('Internet Explorer') && navigator.appName == "Microsoft Internet Explorer" && parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE","")) < 9){
        console.log("您的浏览器版本过低，请使用IE9及以上版本");
        isIE = browser.is('Internet Explorer');
    }
}

let Player = PcPlayer;

// baidu爬虫时也使用flash播放器 ua: Baiduspider-render
// IE下全部使用flash
if (
    isIE ||
    (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent.includes('Baiduspider-render'))
) {
    Player = FlashPlayer;
}

export default Player;
